import  { useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import LaddaButton from "../../buttons/laddaButton";

const ForeignTradeUpdateWarningModal = ({
  open,
  handleClose,
  onProceed,
  data
}) => {
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    try {
      setLoading(true);
      if (typeof onProceed === "function") {
        await onProceed(data);
      }
    } finally {
      setLoading(false);
      handleClose?.();
    }
  };

  const registrationNumber = data?.form?.registration_number ?? "";
  const productName = data?.form?.product ?? "";
  const startDate = data?.formDisplay?.start_date ?? data?.form?.start_date ?? "";
  const endDate = data?.formDisplay?.end_date ?? data?.form?.end_date ?? "";

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="update-warning-modal-title"
    >
      <DialogContent>
        <b className="button_text">Confirmar actualización de registro</b>

        <div className="IHContainer align-center mt-10">
          <img
            className="icon-verification mr-10"
            src={"/icons/verification_warn.png"}
            alt="warn"
          />
          <div className="VContainer">
            <p className="verification-modal-text m-0">
              <b>Número de Registro:</b> {registrationNumber}. <b>Producto:</b> {productName}.
            </p>
            <p className="verification-modal-text">
              Usted <b>NO</b> está creando un nuevo registro; está <b>ACTUALIZANDO</b> el existente.
            </p>
            <p className="verification-modal-text">
              <b>Nueva vigencia propuesta:</b> {startDate} – {endDate}
            </p>

            <b className="verification-modal-text">
              ¿Desea continuar con la actualización?
            </b>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <LaddaButton
          color="6A6AD8"
          backgroundColor={"white"}
          onClick={handleClose}
        >
          <div className="HContainer align-center">
            <p className="button_text">Volver</p>
          </div>
        </LaddaButton>

        <LaddaButton
          variant="contained"
          onClick={handleContinue}
          loading={loading}
        >
          <div className="HContainer align-center">
            <p className="button_text">Continuar</p>
          </div>
        </LaddaButton>
      </DialogActions>
    </Dialog>
  );
};

export default ForeignTradeUpdateWarningModal;
